function constant(value) {
    return () => value;
}

export { constant };
